<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-16",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 36,
      nextPage: '/questionnaire/section2/17',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/21-Menstrual problems.png'),
        mainTitle: 'Is your menstrual period regular?',
        btn: [
          [
            {
              text: 'Yes',
            },{
              text: 'No',
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
